import { isString } from 'lodash';

import { FAILURE_TYPES, FAILURE_NAMES } from '../../validationConstants';
import { ERROR_LOCALE_KEYS } from '../../../error/errorLocaleKeys';

const OBJECT_ERROR_OBJECT = {
    name: FAILURE_NAMES.object,
    type: FAILURE_TYPES.ERROR,
    message: 'Must be a string',
    errorLocaleKey: ERROR_LOCALE_KEYS.VALIDATION.HTML,
};

export default (fieldValue, validationConfig) => {
    if (!fieldValue) return;

    if (!isString(fieldValue)) return OBJECT_ERROR_OBJECT;

    return null;
};
